import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const topStats = [{
  value: '+150',
  label: 'SESIONES LISTAS'
}, {
  value: '+5000',
  label: 'PROFES SATISFECHAS'
}, {
  value: '3.800+',
  label: 'HORAS AHORRADAS'
}, {
  value: '99%',
  label: 'LO RECOMIENDAN'
}];
const antes = ['Horas planificando cada clase', 'Clases repetitivas', 'Sin progresión real', 'No saber qué cobrar', 'Alumnos que se van'];
const conPilates = ['5 minutos de repaso', 'Clases con variedad', 'Progresión clara por nivel', 'Precios claros y confianza', 'Comunidad fiel'];
const bottomStats = [{
  value: '+150',
  label: 'SESIONES'
}, {
  value: '12',
  label: 'TOMOS'
}, {
  value: '100%',
  label: 'DESCARGABLE'
}];
export const Problem = () => {
  return <>
      {/* Top Stats Bar */}
      <section className="bg-white border-b border-brand-sand py-10 sm:py-12" data-id="element-142">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8" data-id="element-144">
            {topStats.map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className={`text-center px-4 ${i > 0 ? 'md:border-l md:border-brand-sand' : ''}`} data-id="element-145">
                <div className="font-serif font-bold text-brand-charcoal text-3xl sm:text-4xl md:text-5xl mb-2" data-id="element-146">
                  {stat.value}
                </div>
                <div className="text-gray-500 text-xs sm:text-sm font-semibold tracking-wide uppercase" data-id="element-147">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Transformation + Comparison */}
      <section className="bg-brand-cream py-16 sm:py-24" data-id="element-148">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-150">
            {/* Left: Headline + Highlight Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-151">
              <h2 className="text-4xl sm:text-5xl font-serif font-bold text-brand-charcoal leading-[1.1] mb-8" data-id="element-152">
                De una profesora sobrecargada a una{' '}
                <span className="italic text-brand-terracotta" data-id="element-153">
                  guía inspirada.
                </span>
              </h2>

              <div className="bg-white rounded-2xl shadow-sm border border-brand-sand p-6 sm:p-8 flex items-center gap-5 max-w-md" data-id="element-154">
                <div className="font-serif font-bold text-brand-terracotta text-5xl sm:text-6xl leading-none flex-shrink-0" data-id="element-155">
                  3.800+
                </div>
                <div className="text-gray-600 text-sm sm:text-base leading-snug" data-id="element-156">
                  horas ahorradas al año en planificación.
                </div>
              </div>
            </motion.div>

            {/* Right: Comparison Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-white rounded-3xl shadow-lg border border-brand-sand overflow-hidden" data-id="element-157">
              <div className="grid grid-cols-2" data-id="element-158">
                {/* Antes */}
                <div className="p-6 sm:p-8" data-id="element-159">
                  <div className="flex items-center gap-2 mb-6" data-id="element-160">
                    <span className="w-6 h-6 rounded-full bg-red-100 text-red-500 flex items-center justify-center flex-shrink-0" data-id="element-161">
                      <X size={14} strokeWidth={3} data-id="element-162" />
                    </span>
                    <span className="text-brand-terracotta font-bold text-sm tracking-wide uppercase" data-id="element-163">
                      Antes
                    </span>
                  </div>
                  <ul className="space-y-5" data-id="element-164">
                    {antes.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-165">
                        <X size={16} className="text-red-400 flex-shrink-0 mt-1" strokeWidth={2.5} data-id="element-166" />
                        <span className="text-gray-500 text-sm sm:text-[15px] leading-snug" data-id="element-167">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                {/* Con Pilates 360 */}
                <div className="p-6 sm:p-8 bg-brand-sand/25 border-l border-brand-sand" data-id="element-168">
                  <div className="flex items-center gap-2 mb-6" data-id="element-169">
                    <span className="w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center flex-shrink-0" data-id="element-170">
                      <Check size={14} strokeWidth={3} data-id="element-171" />
                    </span>
                    <span className="text-brand-charcoal font-bold text-sm tracking-wide uppercase" data-id="element-172">
                      Con Pilates 360
                    </span>
                  </div>
                  <ul className="space-y-5" data-id="element-173">
                    {conPilates.map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-174">
                        <Check size={16} className="text-green-600 flex-shrink-0 mt-1" strokeWidth={2.5} data-id="element-175" />
                        <span className="text-brand-charcoal font-semibold text-sm sm:text-[15px] leading-snug" data-id="element-176">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Bottom Stat Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-6 mt-14 sm:mt-16 max-w-4xl mx-auto" data-id="element-177">
            {bottomStats.map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-white rounded-2xl shadow-sm border border-brand-sand py-8 text-center" data-id="element-178">
                <div className="font-serif font-bold text-brand-charcoal text-4xl sm:text-5xl mb-2" data-id="element-179">
                  {stat.value}
                </div>
                <div className="text-gray-500 text-xs sm:text-sm font-semibold tracking-wide uppercase" data-id="element-180">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </>;
};